import React, { useState } from 'react';
import aws_exports from './aws-exports';
import { Amplify, Auth } from 'aws-amplify';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Home from './components/Home';
import Results from './components/Results';
// import Queue from './components/Queue';
import { SignIn, SignOut } from "./auth";
import './App.css';
import HomeUnauth from './components/HomeUnauth';
import Loading from './components/Loading';

Amplify.configure(aws_exports);

export default function App() {

  const [user, setUser] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  

  Auth.currentAuthenticatedUser({
    bypassCache: false
  }).then(
    user => {
      setUser(user.username);
      setIsLogin(true);
      setIsLoaded(true);
    }
  )
    .catch(err => {
      console.log(err);
      setIsLogin(false);
      setIsLoaded(true);
    });

  return (
    <Router>
      <Switch>
        <Route path="/signin" component={SignIn} />
        <Route path="/signout" component={SignOut} />
        <Route path="/results">
        {
            isLoaded
              ?
              (
                isLogin
                ?
                <Results />
                :
                <Redirect to="/" />
              )
              :
              <Loading />
          }
        </Route>
        {/* <Route path="/queue">
          {
            isLoaded
              ?
              (
                isLogin
                ?
                <Queue />
                :
                <Redirect to="/" />
              )
              :
              <Loading />
          }

        </Route> */}
        <Route path="/home">
          {
            isLoaded
              ?
              (
                isLogin
                ?
                <Home />
                :
                <Redirect to="/" />
              )
              :
              <Loading />
          }

        </Route>
        <Route path="/">
          
           {
            isLoaded
              ?
              (
                isLogin
                ?
                <Redirect to="/home" />
                :
                <HomeUnauth />
              )
              :
              <Loading />
          }
        </Route>
      </Switch>
    </Router>
  )
};
